import Quirk from './Quirk.otf';
export default { Quirk };
